import React from 'react';
import * as Styled from './styled';
import { ReportResult } from '../../../models';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';

interface ExportNameCellProps {
  cell: TableCell;
}

function ExportNameCell({ cell }: ExportNameCellProps): JSX.Element {
  const rowData = cell.row.original as ReportResult;
  return <Styled.ExportNameCell>{rowData.taskName}</Styled.ExportNameCell>;
}

export default ExportNameCell;
